import Avatar1 from '../../assets/avatar1.jpg';
import Avatar2 from '../../assets/avatar2.jpg';
import Avatar3 from '../../assets/avatar3.jpg';
import Avatar4 from '../../assets/avatar4.jpg';
import Avatar5 from '../../assets/avatar5.jpg';

const data = [
  {
    id: 1,
    quote: "Kai is incredibly detail-oriented and reliable. The project was delivered exactly as discussed, and communication throughout the process was clear and professional.",
    avatar: Avatar1,
    name: "Viet Nguyen",
    profession: "Software Engineer"
  },
  {
    id: 2,
    quote: "Working with Kai was a great experience. Strong technical skills, thoughtful design choices, and always open to feedback.",
    avatar: Avatar2,
    name: "Trung Nguyen",
    profession: "Data Analyst"
  },
  {
  id: 3,
  quote: "Kai brings a strong balance of technical skill and creativity. The work was well-structured, efficient, and delivered on time.",
  avatar: Avatar3,
  name: "The Anh Nguyen",
  profession: "Computer Science Student"
},
{
  id: 4,
  quote: "Very collaborative and easy to work with. Kai explained ideas clearly and was always willing to iterate to improve the final result.",
  avatar: Avatar4,
  name: "Tasin",
  profession: "UI/UX Designer"
},
{
  id: 5,
  quote: "Kai is proactive and dependable. The project workflow was smooth, and the final outcome met all expectations.",
  avatar: Avatar5,
  name: "Mustafa",
  profession: "Software Engineering Intern"
}
];

export default data;
